module.exports = __webpack_public_path__ + "images/PEDESTRIAN.779b711f5f014508760a1e63098bbc04.png";